// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Avatar__avatar-image-c9f1f2 {
  object-fit: cover;
  width: inherit;
  height: inherit;
  box-sizing: border-box;
  border-radius: var(--avatar-border-radius);
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/Removable/components/Avatar/Avatar.styles.m.css"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,cAAA;EACA,eAAA;EACA,sBAAA;EACA,0CAAA;AACF","sourcesContent":[".avatar-image {\n  object-fit: cover;\n  width: inherit;\n  height: inherit;\n  box-sizing: border-box;\n  border-radius: var(--avatar-border-radius);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"avatar-image": `Avatar__avatar-image-c9f1f2`,
	"avatarImage": `Avatar__avatar-image-c9f1f2`
};
module.exports = ___CSS_LOADER_EXPORT___;
